import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Button } from '@mui/material';

export default function ResetPasswordDialog({ open, user, onClose, onReset }) {
    const [pwd, setPwd] = React.useState('');
    const [submitting, setSubmitting] = React.useState(false);

    React.useEffect(() => { setPwd(''); }, [open]);

    const handleReset = async () => {
        if (!pwd || pwd.length < 6) return;
        setSubmitting(true);
        try { await onReset(user, pwd); }
        finally { setSubmitting(false); }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Réinitialiser le mot de passe</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Utilisateur: <b>{user?.email}</b>
                </Typography>
                <TextField
                    fullWidth
                    label="Nouveau mot de passe"
                    type="password"
                    value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button onClick={handleReset} disabled={submitting} variant="contained">Réinitialiser</Button>
            </DialogActions>
        </Dialog>
    );
}
